// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/fractalgraphic-fullcolor-solid.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/pixel-art-screenshot.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/algorithmic-art-screenshot.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/ai-art-screenshot.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styling for Explore page */

#explore-page-content {
    padding: 40px;
  
    display: flex;
    flex-direction: row;
    gap: 20px;
  
    height: 100%;
}

#static-content {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

#digital-expeditions {
    display: flex;
    flex-direction: row;
    gap: 20px;
    text-align: center;
}

#digital-expeditions > div:hover {
    cursor: pointer;
}

#digital-expeditions > div {
    border-radius: 15px;

    background-color: #430156;
    color: white;

    height: 20vw;
    width: 20vw;

    display: flex;
    justify-content: center;
    align-items: center;

    font-family: "proxima-nova", sans-serif;
    font-weight: 800;
    font-size: max(3vh, 15px);

    padding: 10px;
}

.selected-expedition {
    background-color: var(--dark-purple)!important;
    color: white!important;

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right bottom;
    background-size: 65% auto;
}

/* Pixel Art digital experience is selected - change image */
.selected-pixel {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

/* Algorithmic Art digital experience is selected - change image */
.selected-algorithmic {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

/* AI Art digital experience is selected - change image */
.selected-ai {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

#selected-expedition-bg {
    width: 100%;

    background-repeat: no-repeat;
    background-size: cover;
    background-position: right;

    height: 80dvh;

    position: sticky;
    top: 5dvh;

    border-radius: 15px;
}

#selected-expedition {
    background-image: linear-gradient(rgba(0,0,0,0), #430156 70%);
    color: white;

    height: 100%;
    width: 100%;

    border-radius: 15px;

    visibility: hidden;

    align-self: stretch;

    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;

    padding: 20px;

    margin-top: 5vh;

    text-align: center;
}

#selected-expedition > * {
    width: 80%;
    margin: 10px;
}

#launch-button {
    background-color: var(--blue);
    color: white;

    border-radius: 10px;
    border-style: none;

    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    padding-right: 20px;

    font-weight: bold;
}

.explore-pg-ext-link {
    background-color: var(--dark-purple);
    color: white;
    text-decoration: none;
    padding: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.explore-pg-ext-link:hover {
    background-color: color-mix(in srgb, var(--dark-purple) 75%, black);
}

.explore-pg-ext-link img {
    height: 33;
}

#faq > h2 {
    margin-top: 25px;
    margin-bottom: 10px;
}

#faq-content {
    width: 100%;

    background-color: white;

    border-radius: 15px;
    border-style: solid;
    border-width: 1px;
    border-color: #cccccc;

    padding: 40px;
}

@media screen and (max-width: 800px) {
    #digital-expeditions {
        flex-direction: column;
    }
    
    #digital-expeditions > div {
        width: 100% !important;
        height: 10vh !important;
    }

    #explore-page-content {
        flex-direction: column;
    }

    #selected-expedition-bg {
        padding: 0;
        margin: 0;
    }

    #selected-expedition {
        padding: 10px;
        margin: 0;
    }

    #selected-expedition-bg {
        height: auto;
        background-image: none;
    }

    #selected-expedition {
        background-color: var(--dark-purple);
    }

    /* #selected-expedition > h3, #selected-expedition > h4 {
        display: none;
    } */

    #selected-expedition > h3 {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/css/ExplorePage.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B;IACI,aAAa;;IAEb,aAAa;IACb,mBAAmB;IACnB,SAAS;;IAET,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;;IAEnB,yBAAyB;IACzB,YAAY;;IAEZ,YAAY;IACZ,WAAW;;IAEX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,uCAAuC;IACvC,gBAAgB;IAChB,yBAAyB;;IAEzB,aAAa;AACjB;;AAEA;IACI,8CAA8C;IAC9C,sBAAsB;;IAEtB,yDAAmE;IACnE,4BAA4B;IAC5B,iCAAiC;IACjC,yBAAyB;AAC7B;;AAEA,4DAA4D;AAC5D;IACI,yDAAyD;AAC7D;;AAEA,kEAAkE;AAClE;IACI,yDAA+D;AACnE;;AAEA,yDAAyD;AACzD;IACI,yDAAsD;AAC1D;;AAEA;IACI,WAAW;;IAEX,4BAA4B;IAC5B,sBAAsB;IACtB,0BAA0B;;IAE1B,aAAa;;IAEb,gBAAgB;IAChB,SAAS;;IAET,mBAAmB;AACvB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;;IAEZ,YAAY;IACZ,WAAW;;IAEX,mBAAmB;;IAEnB,kBAAkB;;IAElB,mBAAmB;;IAEnB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;;IAEnB,aAAa;;IAEb,eAAe;;IAEf,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;;IAEZ,mBAAmB;IACnB,kBAAkB;;IAElB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;;IAEnB,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,qBAAqB;IACrB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,mEAAmE;AACvE;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;;IAEX,uBAAuB;;IAEvB,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;;IAErB,aAAa;AACjB;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,UAAU;QACV,SAAS;IACb;;IAEA;QACI,aAAa;QACb,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,sBAAsB;IAC1B;;IAEA;QACI,oCAAoC;IACxC;;IAEA;;OAEG;;IAEH;QACI,aAAa;IACjB;AACJ","sourcesContent":["/* Styling for Explore page */\n\n#explore-page-content {\n    padding: 40px;\n  \n    display: flex;\n    flex-direction: row;\n    gap: 20px;\n  \n    height: 100%;\n}\n\n#static-content {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n#digital-expeditions {\n    display: flex;\n    flex-direction: row;\n    gap: 20px;\n    text-align: center;\n}\n\n#digital-expeditions > div:hover {\n    cursor: pointer;\n}\n\n#digital-expeditions > div {\n    border-radius: 15px;\n\n    background-color: #430156;\n    color: white;\n\n    height: 20vw;\n    width: 20vw;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    font-family: \"proxima-nova\", sans-serif;\n    font-weight: 800;\n    font-size: max(3vh, 15px);\n\n    padding: 10px;\n}\n\n.selected-expedition {\n    background-color: var(--dark-purple)!important;\n    color: white!important;\n\n    background-image: url(../images/fractalgraphic-fullcolor-solid.svg);\n    background-repeat: no-repeat;\n    background-position: right bottom;\n    background-size: 65% auto;\n}\n\n/* Pixel Art digital experience is selected - change image */\n.selected-pixel {\n    background-image: url(../images/pixel-art-screenshot.png);\n}\n\n/* Algorithmic Art digital experience is selected - change image */\n.selected-algorithmic {\n    background-image: url(../images/algorithmic-art-screenshot.png);\n}\n\n/* AI Art digital experience is selected - change image */\n.selected-ai {\n    background-image: url(../images/ai-art-screenshot.png);\n}\n\n#selected-expedition-bg {\n    width: 100%;\n\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: right;\n\n    height: 80dvh;\n\n    position: sticky;\n    top: 5dvh;\n\n    border-radius: 15px;\n}\n\n#selected-expedition {\n    background-image: linear-gradient(rgba(0,0,0,0), #430156 70%);\n    color: white;\n\n    height: 100%;\n    width: 100%;\n\n    border-radius: 15px;\n\n    visibility: hidden;\n\n    align-self: stretch;\n\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    align-items: center;\n\n    padding: 20px;\n\n    margin-top: 5vh;\n\n    text-align: center;\n}\n\n#selected-expedition > * {\n    width: 80%;\n    margin: 10px;\n}\n\n#launch-button {\n    background-color: var(--blue);\n    color: white;\n\n    border-radius: 10px;\n    border-style: none;\n\n    padding-top: 10px;\n    padding-bottom: 10px;\n    padding-left: 20px;\n    padding-right: 20px;\n\n    font-weight: bold;\n}\n\n.explore-pg-ext-link {\n    background-color: var(--dark-purple);\n    color: white;\n    text-decoration: none;\n    padding: 20px;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.explore-pg-ext-link:hover {\n    background-color: color-mix(in srgb, var(--dark-purple) 75%, black);\n}\n\n.explore-pg-ext-link img {\n    height: 33;\n}\n\n#faq > h2 {\n    margin-top: 25px;\n    margin-bottom: 10px;\n}\n\n#faq-content {\n    width: 100%;\n\n    background-color: white;\n\n    border-radius: 15px;\n    border-style: solid;\n    border-width: 1px;\n    border-color: #cccccc;\n\n    padding: 40px;\n}\n\n@media screen and (max-width: 800px) {\n    #digital-expeditions {\n        flex-direction: column;\n    }\n    \n    #digital-expeditions > div {\n        width: 100% !important;\n        height: 10vh !important;\n    }\n\n    #explore-page-content {\n        flex-direction: column;\n    }\n\n    #selected-expedition-bg {\n        padding: 0;\n        margin: 0;\n    }\n\n    #selected-expedition {\n        padding: 10px;\n        margin: 0;\n    }\n\n    #selected-expedition-bg {\n        height: auto;\n        background-image: none;\n    }\n\n    #selected-expedition {\n        background-color: var(--dark-purple);\n    }\n\n    /* #selected-expedition > h3, #selected-expedition > h4 {\n        display: none;\n    } */\n\n    #selected-expedition > h3 {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
